import React, { useState } from "react";
import Seo from "../components/Seo";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Button } from "../components/ui/button";
import { Mail, Phone, MapPin } from "lucide-react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

export default function Contact() {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const submit = (e) => {
    e.preventDefault();
    toast.success(t("contact.successMessage"));
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <><Seo title="Contact Us" description="Get in touch with Universal Tree. Reach out for support, partnership inquiries, or feedback." />
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="max-w-7xl mx-auto px-6 lg:px-12 py-8 md:py-20 flex-1 grid lg:grid-cols-2 gap-16 w-full">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-[#D9734E] font-bold">{t("contact.subtitle")}</p>
          <h1 className="font-display text-5xl lg:text-6xl font-light tracking-tight mt-3">{t("contact.title")}</h1>
          <p className="mt-6 text-lg text-[#646964] max-w-md leading-relaxed">
            {t("contact.description")}
          </p>

          <ul className="mt-10 space-y-5 text-sm">
            <li className="flex items-center gap-4"><span className="w-10 h-10 grid place-items-center bg-[#1C4532] text-white rounded-sm"><Mail size={16}/></span>hello@universaltree.io</li>
            <li className="flex items-center gap-4"><span className="w-10 h-10 grid place-items-center bg-[#1C4532] text-white rounded-sm"><Phone size={16}/></span>+91 80000 12345</li>
            <li className="flex items-center gap-4"><span className="w-10 h-10 grid place-items-center bg-[#1C4532] text-white rounded-sm"><MapPin size={16}/></span>Indiranagar, Bengaluru 560038</li>
          </ul>
        </div>

        <form onSubmit={submit} className="bg-white p-8 lg:p-10 rounded-sm border border-[#E2E0D9] space-y-5">
          <div>
            <label className="text-xs uppercase tracking-wider text-[#646964] mb-2 block">{t("contact.form.name")}</label>
            <Input data-testid="contact-name" required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="rounded-sm"/>
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-[#646964] mb-2 block">{t("contact.form.email")}</label>
            <Input type="email" data-testid="contact-email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="rounded-sm"/>
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-[#646964] mb-2 block">{t("contact.form.message")}</label>
            <Textarea rows={6} data-testid="contact-message" required value={form.message} onChange={e => setForm({...form, message: e.target.value})} className="rounded-sm"/>
          </div>
          <Button type="submit" data-testid="contact-submit" className="rounded-sm bg-[#1C4532] hover:bg-[#143324] text-white w-full py-6">{t("contact.form.submit")}</Button>
        </form>
      </main>
      <Footer />
    </div>
    </>
  );
}
